import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getDeployment } from '@/redux/modules/config';
import { getSellerDetailsByIds } from '@/redux/modules/seller/details/sellerDetails.api';
import { whichSellerDetailsNeeded } from '@/redux/modules/seller/details/sellerDetails.selectors';
import { SellerDetails } from '@/types/SellerDetails';

export const fetchSellerDetailsByIds = createAsyncThunk<SellerDetails[], number[]>(
    'la/ui/sellerDetails/fetchSellerDetailsByIds',
    async (sellerIds, { getState }) => {
        const state = getState();
        const deployment = getDeployment(state);
        const response = await getSellerDetailsByIds({
            deployment,
            sellerIds,
        });
        return response.data.sellerDetails;
    }
);

export const fetchSellerDetailsByIdsIfNeeded = createAsyncThunk<void, number[]>(
    'la/ui/sellerDetails/fetchSellerDetailsByIdsIfNeeded',
    async (sellerIds, { dispatch, getState }) => {
        const needed = whichSellerDetailsNeeded(getState(), sellerIds);
        if (needed.length) {
            await dispatch(fetchSellerDetailsByIds(needed));
        }
    }
);
